<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue';
import { useStore } from '@/store/store.ts';

const store = useStore();

const props = withDefaults(
  defineProps<{
    name_modal?: string;
  }>(),
  {
    name_modal: '',
  },
);

const closeOutModal = () => {
  if (window.innerWidth >= 1200) {
    store.closeModal(props.name_modal);
  }
};
const closeModal = () => {
  store.closeModal(props.name_modal);
};

onMounted(() => {
  document.body.classList.add('lock');
  document.body.style.overflowY = 'hidden';
});

onBeforeUnmount(() => {
  document.body.classList.remove('lock');
  document.body.style.overflowY = 'auto';
});
</script>

<template>
  <div
    class="modal"
    @click="closeOutModal"
    :class="{ '--improve': props.name_modal === 'improve' }"
  >
    <div
      class="wrapper"
      @click.stop
      :class="{ offsetTop: props.name_modal === 'order' || props.name_modal === 'improve' }"
    >
      <div class="cross" v-if="props.name_modal !== 'improve'">
        <svg-icon :name="'cross'" @click="closeModal" />
      </div>
      <div class="close" v-else>
        <svg-icon :name="'close3'" :width="32" :height="32" @click="closeModal" />
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modal {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #000000e5;
  z-index: 1000;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
  cursor: pointer;
  &.--improve {
    .wrapper {
      width: 896px;
      padding: 96px;
    }
  }
  .wrapper {
    padding: 88px 12px;
    gap: 8px;
    width: 800px;
    min-height: 435px;
    background: #ffffff;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin: auto auto;
    cursor: default;
    .cross {
      top: 24px;
      right: 24px;
      position: absolute;
      color: var(--orange);
      cursor: pointer;
      transition: all 0.15s ease;
      @media (hover: hover) {
        &:hover {
          color: #ffa133;
        }
      }
      svg {
        width: 36px !important;
        height: 36px !important;
      }
    }
    .close {
      top: 24px;
      right: 24px;
      position: absolute;
      transition: all 0.15s ease;
      width: 64px;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #A99D91;
      cursor: pointer;
      @media (hover: hover) {
        &:hover {
          color: #BAA896;
        }
      }
      &:active {
        color: #A49383;
      }
    }
  }
}
@include for-mobile {
  .modal {
    background: #fff;
    padding: 0px;
    cursor: default;
    &.--improve {
      .wrapper {
        width: 100%;
        padding: 88px 0 0;
        margin-top: 0 !important;
      }
    }
    .wrapper {
      min-width: 360px;
      width: 100%;
      padding: 0;
      align-items: stretch;
      position: static;
      margin-top: 96px;
      &.offsetTop {
        margin-top: 36px;
      }
      .cross {
        top: 8px;
        right: 12px;
      }
      .close {
        top: 8px;
        right: 8px;
        position: absolute;
        color: #A99D91;
        cursor: pointer;
        transition: all 0.15s ease;
        width: 48px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        .svg-icon {
          width: 24px !important;
          height: 24px !important;
        }
        &:active {
          color: #A49383;
        }
      }
    }
  }
}
</style>
